import React, { useState, Fragment, useContext, createContext } from "react";
import { Fade, Modal } from "@mui/material";
import { Svg } from "assets";

export const PrimaryModalContext = createContext(null);

export const PrimaryModalProvider = ({ children }) => {
  const [params, setParams] = useState({});
  const [modalInfo, setModalInfo] = useState({});

  return (
    <Fragment>
      <PrimaryModalContext.Provider
        value={{
          params,
          setParams,
          modalInfo,
          setModalInfo,
        }}
      >
        {children}
      </PrimaryModalContext.Provider>
    </Fragment>
  );
};
export const usePrimaryModal = () => {
  const { params, setParams, modalInfo, setModalInfo } =
    useContext(PrimaryModalContext);
  return {
    openPrimary: (params = {}, modalInfo) => {
      setParams(params);
      setModalInfo(modalInfo);
    },
    closePrimary: () => {
      setParams({});
      setModalInfo({});
    },
    params,
    modalInfo,
  };
};
export const PrimaryModal = () => {
  const { closePrimary, params, modalInfo } = usePrimaryModal();

  const renderOpen = Object.keys(params).length !== 0;

  return (
    renderOpen && (
      <Modal
        style={{ zIndex: "1405" }}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={renderOpen}
        onClose={() => closePrimary()}
        closeAfterTransition
        hideBackdrop={false}
      >
        <Fade in={renderOpen}>
          <div
            style={
                {
                    padding: modalInfo?.padding === "noPaddings" ? 0 : '',
                    outline: modalInfo?.padding === "noPaddings" ? 'none' : 'none',
                    maxWidth: modalInfo?.maxWidth ? modalInfo?.maxWidth : 'inherit'
                }
            }
            className={`modal-wrapper ${
              modalInfo?.className ? modalInfo?.className : ""
            }`}
          >
            {!modalInfo?.noShowCloseBtn && (
              <div className="modal-header-style">
                <button
                  type="button"
                  className="close-modal-btn"
                  onClick={() => closePrimary()}
                >
                  <Svg.CloseSvg />
                </button>
              </div>
            )}
            <div className="modal-body-style">{params}</div>
          </div>
        </Fade>
      </Modal>
    )
  );
};
